import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { wallet } from './types/index';
import { tr } from 'date-fns/locale';

export const getWalletAmount = async(): Promise<any | null> => {
 try {
    const response = await axios.get(`/api/v1/user/fetchUserWalletBalance`);
      return response.data;
  } catch (error) {
      console.error('Failed to fetch wallet amount:', error);
    return null;
  }
};

type QueryFnType = typeof getWalletAmount;

type UseLotteryByIdOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useWalletAmount = ({ config }: UseLotteryByIdOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryFn: () => getWalletAmount(),
    ...config,
  });
};